import { useId } from 'react'
import { cn } from '@/lib/utils'

/** Signetix mark: a rounded "screen" with three signal lines and a live dot. */
export function LogoMark({ className, title = 'Signetix' }: { className?: string; title?: string }) {
  const id = useId()
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8 shrink-0', className)} role="img" aria-label={title}>
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="oklch(0.56 0.24 290)" />
          <stop offset="0.55" stopColor="oklch(0.55 0.21 265)" />
          <stop offset="1" stopColor="oklch(0.74 0.14 210)" />
        </linearGradient>
        <linearGradient id={`${id}-s`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#fff" stopOpacity="0.28" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8.5" fill={`url(#${id}-g)`} />
      <rect width="32" height="16" rx="8.5" fill={`url(#${id}-s)`} />
      <path d="M9 11.25h14M9 16h8.5M9 20.75h14" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="22.4" cy="16" r="1.9" fill="#fff" />
    </svg>
  )
}

export function Logo({ className, collapsed = false }: { className?: string; collapsed?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark />
      {!collapsed && <span className="text-[17px] font-semibold tracking-tight">Signetix</span>}
    </span>
  )
}
